import { render, staticRenderFns } from "./Payers.vue?vue&type=template&id=20061b50&scoped=true&"
import script from "./Payers.vue?vue&type=script&lang=js&"
export * from "./Payers.vue?vue&type=script&lang=js&"
import style0 from "./Payers.vue?vue&type=style&index=0&id=20061b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20061b50",
  null
  
)

export default component.exports